// extracted by mini-css-extract-plugin
export default {"fields":"hnTZ7S","gaps":"pxaQjW","time":"y2io71","mobile":"qd_3xS"};